import React, { useState } from 'react';
import { NewSearch } from '../Components/PIM/common/NewSearch';
import {
  ActionIcon,
  ActiveIcon,
  ActivityIcon,
  AddIcon,
  AddReactionIcon,
  AiFileIcon,
  AlignBottomInsideIcon,
  AlignCentreIcon,
  AlignLeftIcon,
  AlignMiddleInsideIcon,
  AlignRightIcon,
  AlignTopInsideIcon,
  ApproveIcon,
  AppsIcon,
  ArchiveIcon,
  ArrowIcon,
  AssetLibraryIcon,
  AutomationIcon,
  BarChartIcon,
  BillOfMaterialsIcon,
  BoldIcon,
  BOMConfigIcon,
  LibraryGroupIcon,
  BottomsUpIcon,
  BugIcon,
  BulkEditIcon,
  BulkSaveIcon,
  BulletPointsEmptyIcon,
  BulletPointsSolidIcon,
  CalendarIcon,
  CalendarIcon2,
  CameraIcon,
  CardViewIcon,
  CareLibraryIcon,
  CareSymbolsIcon,
  CareUserInstructionsIcon,
  CarouselIcon,
  CertificationsIcon,
  ChatIcon,
  CheckBoxIcon,
  ChevronIcon,
  ClearHighlightsIcon,
  ClearIcon,
  CloseIcon,
  CollapseIcon,
  ColourCodingIcon,
  ColourLibraryIcon,
  CommentsIcon,
  CompareIcon,
  CostingLibraryIcon,
  CostingsIcon,
  CostingToDoIcon,
  CriticalPathIcon,
  CropIcon,
  CSVFileIcon,
  CustomModulesIcon,
  DAMIcon,
  DatabaseSourceIcon,
  DecreaseIcon,
  DeleteIcon,
  DependenciesIcon,
  DesignDetailsIcon,
  DownloadIcon,
  DPPLibraryIcon,
  DuplicateIcon,
  DurationCounterIcon,
  DxfFileIcon,
  EditIcon,
  EmoteIcon,
  EURIcon,
  ExcelIcon,
  ExpandIcon,
  FaceIcon,
  FactoryIcon,
  FileIcon,
  FileSearchIcon,
  FilterIcon,
  FormatChangeIcon,
  FormulaFieldsIcon,
  FormulaIcon,
  FourCanvasIcon,
  FreightDutyLibraryIcon,
  GBPIcon,
  GlobeIcon,
  GroupIcon,
  HistoryIcon,
  ImageAndTextIcon,
  ImageFileIcon,
  ImageIcon,
  ImagesIcon,
  InactiveIcon,
  InboxIcon,
  IncreaseIcon,
  InfoIcon,
  INRIcon,
  IntegrationIcon,
  InviteSupplierIcon,
  ItalicIcon,
  LCAReportIcon,
  LibraryIcon,
  LinkIcon,
  BarcodeApplierIcon,
  ListIcon,
  LoadedOrFailedIcon,
  LocationIcon,
  LogIcon,
  LogoIcon,
  LogoutIcon,
  MapIcon,
  MeasurementsIcon,
  MilestoneIcon,
  MoodboardIcon,
  MoreIcon,
  MoveIcon,
  MultiChangePriorityIcon,
  MultiDropdownIcon,
  NGNIcon,
  NoimageIcon,
  NotesIcon,
  NotificationBellIcon,
  NumberFieldIcon,
  NumberListIcon,
  OpenChatControlsIcon,
  PartnerRightsIcon,
  PartnersIcon,
  PauseIcon,
  PdfFileIcon,
  PencilIcon,
  PHPIcon,
  PieChartIcon,
  PIMIcon,
  PinColumnIcon,
  PinIcon,
  PlaceholderManagementIcon,
  PlanningIcon,
  PresentationIcon,
  PreviewIcon,
  ProductGroupIcon,
  ProductIdentifierIcon,
  ProductIdentityIcon,
  ProductImpactIcon,
  ProductInfoIcon,
  ProductInformationIcon,
  ProductJourneyIcon,
  ProductPassportIcon,
  ProductsIcon,
  ProgressIndicatorIcon,
  PublishIcon,
  PurchaseOrderLibraryIcon,
  PurchaseOrdersIcon,
  PurchaseOrderToDoIcon,
  PushIcon,
  QRCodeIcon,
  QuoteIcon,
  RadioButtonIcon,
  RadiusIcon,
  RangePlanIcon,
  RearrangeIcon,
  RecordingIcon,
  RedirectsIcon,
  ReplyIcon,
  RequiredAlertIcon,
  ResendPasswordIcon,
  RFIDIcon,
  RulFileIcon,
  SamplesIcon,
  SamplesToDoIcon,
  SaveIcon,
  SearchIcon,
  SetPasswordIcon,
  SettingsIcon,
  ShareIcon,
  ShowGradingsIcon,
  ShowIcon,
  SingleCanvasIcon,
  SingleSignOnIcon,
  SortAscendingIcon,
  SortDownIcon,
  SortIcon,
  SourceIcon,
  SpecLibraryIcon,
  SpecTemplateLibraryIcon,
  SSOIcon,
  StatusIcon,
  StrikeThroughIcon,
  SubmitAndDownloadIcon,
  SummaryIcon,
  SupplierSuggestIcon,
  SupplierToDoIcon,
  SupportingDocumentsIcon,
  SwapIcon,
  TabIcon,
  TableViewIcon,
  TagsIcon,
  TemplatesIcon,
  TestingIcon,
  TestingLibraryIcon,
  TestingToDoIcon,
  TestReportIcon,
  TestRunIcon,
  TextboxIcon,
  ThreeCanvasIcon,
  TickIcon,
  ToolTipIcon,
  TopsDownIcon,
  TranslateIcon,
  TriggerIcon,
  MessageIcon,
  LocationPinIcon,
  TwoCanvasIcon,
  TwoFAIcon,
  UnarchiveIcon,
  UnderlineIcon,
  UnlinkIcon,
  UpdateIcon,
  UploadIcon,
  UsageIcon,
  USDIcon,
  UserFieldsIcon,
  UserIdIcon,
  UserManagementIcon,
  VariantsIcon,
  WaterIcon,
  WdsFileIcon,
  WeatherIcon,
  WeightIcon,
  WorkflowIcon,
  YENIcon,
  AutoBomIcon
} from '../bombiix-icon';

/**
 * Roster of TSX-SVG icons under `src/bombiix-icon/`. Add a new row here when a
 * new icon component ships.
 */
const BOMBIIX_TSX_ICONS = [
  { Component: ActionIcon, name: 'ActionIcon' },
  { Component: ActiveIcon, name: 'ActiveIcon' },
  { Component: ActivityIcon, name: 'ActivityIcon' },
  { Component: AddIcon, name: 'AddIcon' },
  { Component: AddReactionIcon, name: 'AddReactionIcon' },
  { Component: AiFileIcon, name: 'AiFileIcon' },
  { Component: AlignBottomInsideIcon, name: 'AlignBottomInsideIcon' },
  { Component: AlignCentreIcon, name: 'AlignCentreIcon' },
  { Component: AlignLeftIcon, name: 'AlignLeftIcon' },
  { Component: AlignMiddleInsideIcon, name: 'AlignMiddleInsideIcon' },
  { Component: AlignRightIcon, name: 'AlignRightIcon' },
  { Component: AlignTopInsideIcon, name: 'AlignTopInsideIcon' },
  { Component: ApproveIcon, name: 'ApproveIcon' },
  { Component: AppsIcon, name: 'AppsIcon' },
  { Component: ArchiveIcon, name: 'ArchiveIcon' },
  { Component: ArrowIcon, name: 'ArrowIcon' },
  { Component: AssetLibraryIcon, name: 'AssetLibraryIcon' },
  { Component: AutomationIcon, name: 'AutomationIcon' },
  { Component: BarChartIcon, name: 'BarChartIcon' },
  { Component: BillOfMaterialsIcon, name: 'BillOfMaterialsIcon' },
  { Component: BoldIcon, name: 'BoldIcon' },
  { Component: BOMConfigIcon, name: 'BOMConfigIcon' },
  { Component: LibraryGroupIcon, name: 'LibraryGroupIcon' },
  { Component: BottomsUpIcon, name: 'BottomsUpIcon' },
  { Component: BugIcon, name: 'BugIcon' },
  { Component: BulkEditIcon, name: 'BulkEditIcon' },
  { Component: BulkSaveIcon, name: 'BulkSaveIcon' },
  { Component: BulletPointsEmptyIcon, name: 'BulletPointsEmptyIcon' },
  { Component: BulletPointsSolidIcon, name: 'BulletPointsSolidIcon' },
  { Component: CalendarIcon, name: 'CalendarIcon' },
  { Component: CalendarIcon2, name: 'CalendarIcon2' },
  { Component: CameraIcon, name: 'CameraIcon' },
  { Component: CardViewIcon, name: 'CardViewIcon' },
  { Component: CareLibraryIcon, name: 'CareLibraryIcon' },
  { Component: CareSymbolsIcon, name: 'CareSymbolsIcon' },
  { Component: CareUserInstructionsIcon, name: 'CareUserInstructionsIcon' },
  { Component: CarouselIcon, name: 'CarouselIcon' },
  { Component: CertificationsIcon, name: 'CertificationsIcon' },
  { Component: ChatIcon, name: 'ChatIcon' },
  { Component: CheckBoxIcon, name: 'CheckBoxIcon' },
  { Component: ChevronIcon, name: 'ChevronIcon' },
  { Component: ClearHighlightsIcon, name: 'ClearHighlightsIcon' },
  { Component: ClearIcon, name: 'ClearIcon' },
  { Component: CloseIcon, name: 'CloseIcon' },
  { Component: CollapseIcon, name: 'CollapseIcon' },
  { Component: ColourCodingIcon, name: 'ColourCodingIcon' },
  { Component: ColourLibraryIcon, name: 'ColourLibraryIcon' },
  { Component: CommentsIcon, name: 'CommentsIcon' },
  { Component: CompareIcon, name: 'CompareIcon' },
  { Component: CostingLibraryIcon, name: 'CostingLibraryIcon' },
  { Component: CostingsIcon, name: 'CostingsIcon' },
  { Component: CostingToDoIcon, name: 'CostingToDoIcon' },
  { Component: CriticalPathIcon, name: 'CriticalPathIcon' },
  { Component: CropIcon, name: 'CropIcon' },
  { Component: CSVFileIcon, name: 'CSVFileIcon' },
  { Component: CustomModulesIcon, name: 'CustomModulesIcon' },
  { Component: DAMIcon, name: 'DAMIcon' },
  { Component: DatabaseSourceIcon, name: 'DatabaseSourceIcon' },
  { Component: DecreaseIcon, name: 'DecreaseIcon' },
  { Component: DeleteIcon, name: 'DeleteIcon' },
  { Component: DependenciesIcon, name: 'DependenciesIcon' },
  { Component: DesignDetailsIcon, name: 'DesignDetailsIcon' },
  { Component: DownloadIcon, name: 'DownloadIcon' },
  { Component: DPPLibraryIcon, name: 'DPPLibraryIcon' },
  { Component: DuplicateIcon, name: 'DuplicateIcon' },
  { Component: DurationCounterIcon, name: 'DurationCounterIcon' },
  { Component: DxfFileIcon, name: 'DxfFileIcon' },
  { Component: EditIcon, name: 'EditIcon' },
  { Component: EmoteIcon, name: 'EmoteIcon' },
  { Component: EURIcon, name: 'EURIcon' },
  { Component: ExcelIcon, name: 'ExcelIcon' },
  { Component: ExpandIcon, name: 'ExpandIcon' },
  { Component: FaceIcon, name: 'FaceIcon' },
  { Component: FactoryIcon, name: 'FactoryIcon' },
  { Component: FileIcon, name: 'FileIcon' },
  { Component: FileSearchIcon, name: 'FileSearchIcon' },
  { Component: FilterIcon, name: 'FilterIcon' },
  { Component: FormatChangeIcon, name: 'FormatChangeIcon' },
  { Component: FormulaFieldsIcon, name: 'FormulaFieldsIcon' },
  { Component: FormulaIcon, name: 'FormulaIcon' },
  { Component: FourCanvasIcon, name: 'FourCanvasIcon' },
  { Component: FreightDutyLibraryIcon, name: 'FreightDutyLibraryIcon' },
  { Component: GBPIcon, name: 'GBPIcon' },
  { Component: GlobeIcon, name: 'GlobeIcon' },
  { Component: GroupIcon, name: 'GroupIcon' },
  { Component: HistoryIcon, name: 'HistoryIcon' },
  { Component: ImageAndTextIcon, name: 'ImageAndTextIcon' },
  { Component: ImageFileIcon, name: 'ImageFileIcon' },
  { Component: ImageIcon, name: 'ImageIcon' },
  { Component: ImagesIcon, name: 'ImagesIcon' },
  { Component: InactiveIcon, name: 'InactiveIcon' },
  { Component: InboxIcon, name: 'InboxIcon' },
  { Component: IncreaseIcon, name: 'IncreaseIcon' },
  { Component: InfoIcon, name: 'InfoIcon' },
  { Component: INRIcon, name: 'INRIcon' },
  { Component: IntegrationIcon, name: 'IntegrationIcon' },
  { Component: InviteSupplierIcon, name: 'InviteSupplierIcon' },
  { Component: ItalicIcon, name: 'ItalicIcon' },
  { Component: LCAReportIcon, name: 'LCAReportIcon' },
  { Component: LibraryGroupIcon, name: 'LibraryGroupIcon' },
  { Component: LibraryIcon, name: 'LibraryIcon' },
  { Component: LinkIcon, name: 'LinkIcon' },
  { Component: ListIcon, name: 'ListIcon' },
  { Component: LoadedOrFailedIcon, name: 'LoadedOrFailedIcon' },
  { Component: LocationIcon, name: 'LocationIcon' },
  { Component: LogIcon, name: 'LogIcon' },
  { Component: LogoIcon, name: 'LogoIcon' },
  { Component: LogoutIcon, name: 'LogoutIcon' },
  { Component: MapIcon, name: 'MapIcon' },
  { Component: MeasurementsIcon, name: 'MeasurementsIcon' },
  { Component: MilestoneIcon, name: 'MilestoneIcon' },
  { Component: MoodboardIcon, name: 'MoodboardIcon' },
  { Component: MoreIcon, name: 'MoreIcon' },
  { Component: MoveIcon, name: 'MoveIcon' },
  { Component: MultiChangePriorityIcon, name: 'MultiChangePriorityIcon' },
  { Component: MultiDropdownIcon, name: 'MultiDropdownIcon' },
  { Component: NGNIcon, name: 'NGNIcon' },
  { Component: NoimageIcon, name: 'NoimageIcon' },
  { Component: NotesIcon, name: 'NotesIcon' },
  { Component: NotificationBellIcon, name: 'NotificationBellIcon' },
  { Component: NumberFieldIcon, name: 'NumberFieldIcon' },
  { Component: NumberListIcon, name: 'NumberListIcon' },
  { Component: OpenChatControlsIcon, name: 'OpenChatControlsIcon' },
  { Component: PartnerRightsIcon, name: 'PartnerRightsIcon' },
  { Component: PartnersIcon, name: 'PartnersIcon' },
  { Component: PauseIcon, name: 'PauseIcon' },
  { Component: PdfFileIcon, name: 'PdfFileIcon' },
  { Component: PencilIcon, name: 'PencilIcon' },
  { Component: PHPIcon, name: 'PHPIcon' },
  { Component: PieChartIcon, name: 'PieChartIcon' },
  { Component: PIMIcon, name: 'PIMIcon' },
  { Component: PinColumnIcon, name: 'PinColumnIcon' },
  { Component: PinIcon, name: 'PinIcon' },
  { Component: PlaceholderManagementIcon, name: 'PlaceholderManagementIcon' },
  { Component: PlanningIcon, name: 'PlanningIcon' },
  { Component: PresentationIcon, name: 'PresentationIcon' },
  { Component: PreviewIcon, name: 'PreviewIcon' },
  { Component: ProductGroupIcon, name: 'ProductGroupIcon' },
  { Component: ProductIdentifierIcon, name: 'ProductIdentifierIcon' },
  { Component: ProductIdentityIcon, name: 'ProductIdentityIcon' },
  { Component: ProductImpactIcon, name: 'ProductImpactIcon' },
  { Component: ProductInfoIcon, name: 'ProductInfoIcon' },
  { Component: ProductInformationIcon, name: 'ProductInformationIcon' },
  { Component: ProductJourneyIcon, name: 'ProductJourneyIcon' },
  { Component: ProductPassportIcon, name: 'ProductPassportIcon' },
  { Component: ProductsIcon, name: 'ProductsIcon' },
  { Component: ProgressIndicatorIcon, name: 'ProgressIndicatorIcon' },
  { Component: PublishIcon, name: 'PublishIcon' },
  { Component: PurchaseOrderLibraryIcon, name: 'PurchaseOrderLibraryIcon' },
  { Component: PurchaseOrdersIcon, name: 'PurchaseOrdersIcon' },
  { Component: PurchaseOrderToDoIcon, name: 'PurchaseOrderToDoIcon' },
  { Component: PushIcon, name: 'PushIcon' },
  { Component: QRCodeIcon, name: 'QRCodeIcon' },
  { Component: QuoteIcon, name: 'QuoteIcon' },
  { Component: RadioButtonIcon, name: 'RadioButtonIcon' },
  { Component: RadiusIcon, name: 'RadiusIcon' },
  { Component: RangePlanIcon, name: 'RangePlanIcon' },
  { Component: RearrangeIcon, name: 'RearrangeIcon' },
  { Component: RecordingIcon, name: 'RecordingIcon' },
  { Component: RedirectsIcon, name: 'RedirectsIcon' },
  { Component: ReplyIcon, name: 'ReplyIcon' },
  { Component: RequiredAlertIcon, name: 'RequiredAlertIcon' },
  { Component: ResendPasswordIcon, name: 'ResendPasswordIcon' },
  { Component: RFIDIcon, name: 'RFIDIcon' },
  { Component: RulFileIcon, name: 'RulFileIcon' },
  { Component: SamplesIcon, name: 'SamplesIcon' },
  { Component: SamplesToDoIcon, name: 'SamplesToDoIcon' },
  { Component: SaveIcon, name: 'SaveIcon' },
  { Component: SearchIcon, name: 'SearchIcon' },
  { Component: SetPasswordIcon, name: 'SetPasswordIcon' },
  { Component: SettingsIcon, name: 'SettingsIcon' },
  { Component: ShareIcon, name: 'ShareIcon' },
  { Component: ShowGradingsIcon, name: 'ShowGradingsIcon' },
  { Component: ShowIcon, name: 'ShowIcon' },
  { Component: SingleCanvasIcon, name: 'SingleCanvasIcon' },
  { Component: SingleSignOnIcon, name: 'SingleSignOnIcon' },
  { Component: SortAscendingIcon, name: 'SortAscendingIcon' },
  { Component: SortDownIcon, name: 'SortDownIcon' },
  { Component: SortIcon, name: 'SortIcon' },
  { Component: SourceIcon, name: 'SourceIcon' },
  { Component: SpecLibraryIcon, name: 'SpecLibraryIcon' },
  { Component: SpecTemplateLibraryIcon, name: 'SpecTemplateLibraryIcon' },
  { Component: SSOIcon, name: 'SSOIcon' },
  { Component: StatusIcon, name: 'StatusIcon' },
  { Component: StrikeThroughIcon, name: 'StrikeThroughIcon' },
  { Component: SubmitAndDownloadIcon, name: 'SubmitAndDownloadIcon' },
  { Component: SummaryIcon, name: 'SummaryIcon' },
  { Component: SupplierSuggestIcon, name: 'SupplierSuggestIcon' },
  { Component: SupplierToDoIcon, name: 'SupplierToDoIcon' },
  { Component: SupportingDocumentsIcon, name: 'SupportingDocumentsIcon' },
  { Component: SwapIcon, name: 'SwapIcon' },
  { Component: TabIcon, name: 'TabIcon' },
  { Component: TableViewIcon, name: 'TableViewIcon' },
  { Component: TagsIcon, name: 'TagsIcon' },
  { Component: TemplatesIcon, name: 'TemplatesIcon' },
  { Component: TestingIcon, name: 'TestingIcon' },
  { Component: TestingLibraryIcon, name: 'TestingLibraryIcon' },
  { Component: TestingToDoIcon, name: 'TestingToDoIcon' },
  { Component: TestReportIcon, name: 'TestReportIcon' },
  { Component: TestRunIcon, name: 'TestRunIcon' },
  { Component: TextboxIcon, name: 'TextboxIcon' },
  { Component: ThreeCanvasIcon, name: 'ThreeCanvasIcon' },
  { Component: TickIcon, name: 'TickIcon' },
  { Component: ToolTipIcon, name: 'ToolTipIcon' },
  { Component: TopsDownIcon, name: 'TopsDownIcon' },
  { Component: TranslateIcon, name: 'TranslateIcon' },
  { Component: TriggerIcon, name: 'TriggerIcon' },
  { Component: MessageIcon, name: 'MessageIcon' },
  { Component: LocationPinIcon, name: 'LocationPinIcon' },
  { Component: TwoCanvasIcon, name: 'TwoCanvasIcon' },
  { Component: TwoFAIcon, name: 'TwoFAIcon' },
  { Component: UnarchiveIcon, name: 'UnarchiveIcon' },
  { Component: UnderlineIcon, name: 'UnderlineIcon' },
  { Component: UnlinkIcon, name: 'UnlinkIcon' },
  { Component: UpdateIcon, name: 'UpdateIcon' },
  { Component: UploadIcon, name: 'UploadIcon' },
  { Component: UsageIcon, name: 'UsageIcon' },
  { Component: USDIcon, name: 'USDIcon' },
  { Component: UserFieldsIcon, name: 'UserFieldsIcon' },
  { Component: UserIdIcon, name: 'UserIdIcon' },
  { Component: UserManagementIcon, name: 'UserManagementIcon' },
  { Component: VariantsIcon, name: 'VariantsIcon' },
  { Component: WaterIcon, name: 'WaterIcon' },
  { Component: WdsFileIcon, name: 'WdsFileIcon' },
  { Component: WeatherIcon, name: 'WeatherIcon' },
  { Component: WeightIcon, name: 'WeightIcon' },
  { Component: WorkflowIcon, name: 'WorkflowIcon' },
  { Component: YENIcon, name: 'YENIcon' },
  { Component: AutoBomIcon, name: 'AutoBomIcon' },
  { Component: LinkIcon, name: 'LinkIcon' },
  { Component: BarcodeApplierIcon, name: 'BarcodeApplierIcon' },
];

/**
 * Copy a string to the clipboard. Prefers the async Clipboard API; falls back
 * to the deprecated execCommand path for insecure contexts or older browsers.
 */
async function copyToClipboard(text) {
  if (navigator?.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (error) {
      console.error(error);
    }
  }
  try {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(textarea);
    return ok;
  } catch (_) {
    return false;
  }
}

/**
 * Bombiix TSX icon library — dev catalogue at /bombiix-icons-tsx.
 * Renders every one-file-per-icon SVG component in a searchable grid; click
 * the copy button on a tile to copy its JSX (`<EditIcon />`) to the clipboard.
 */
function BombiixIconsTsx() {
  const [query, setQuery] = useState('');
  const [copiedName, setCopiedName] = useState(null);

  const normalisedQuery = query.trim().toLowerCase();
  const filtered = normalisedQuery ? BOMBIIX_TSX_ICONS.filter((icon) => icon.name.toLowerCase().includes(normalisedQuery)) : BOMBIIX_TSX_ICONS;

  const handleCopy = async (name) => {
    const snippet = `<${name} />`;
    const ok = await copyToClipboard(snippet);
    if (ok) {
      setCopiedName(name);
      setTimeout(() => setCopiedName((current) => (current === name ? null : current)), 1200);
    }
  };

  return (
    <div className="container mt-4 pb-5">
      <h2 className="mb-1">Bombiix TSX Icons</h2>
      <p className="text-muted mb-3">
        One-file-per-icon SVG components from <code>src/bombiix-icon/</code>. Click the copy button to grab the JSX snippet.
      </p>

      <div style={{ maxWidth: 320, marginBottom: 24 }}>
        <NewSearch className="bombiix-search" value={query} onChange={setQuery} placeholder="Search icons" testId="bombiix-icons-tsx-search" />
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))',
          gap: 12,
        }}
      >
        {filtered.map(({ Component, name }) => {
          const isCopied = copiedName === name;
          const snippet = `<${name} />`;
          return (
            <div
              key={name}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 8,
                padding: '16px 8px 8px',
                background: '#ffffff',
                border: `1px solid ${isCopied ? '#73c5af' : '#d8d8d8'}`,
                borderRadius: 4,
                transition: 'border-color 0.15s ease',
              }}
            >
              <span style={{ color: '#3c3c3c' }}>
                <Component size={30} />
              </span>
              <code
                style={{
                  fontSize: 11,
                  color: '#525252',
                  wordBreak: 'break-all',
                  textAlign: 'center',
                  userSelect: 'all',
                  padding: '4px 6px',
                  background: '#f5f5f5',
                  borderRadius: 3,
                  width: '100%',
                }}
              >
                {snippet}
              </code>
              <button
                type="button"
                onClick={() => handleCopy(name)}
                title={`Copy ${snippet}`}
                aria-label={`Copy JSX for ${name}`}
                className={`bombiix-icon-container ${isCopied ? 'bombiix-icon-container--green' : 'bombiix-icon-container--blue'}`}
              >
                <i className={isCopied ? 'bombiix-icon-approve' : 'bombiix-icon-duplicate'} />
              </button>
            </div>
          );
        })}
      </div>

      {filtered.length === 0 && <p className="text-muted mt-4">No icons match &quot;{query}&quot;.</p>}
    </div>
  );
}

export default BombiixIconsTsx;
